export default __webpack_public_path__ + "static/media/sale__package__3cl.c21ce75d.png";